import moment from 'moment';

/**
 * Checks date validity according to ISO-8601 standard
 * @param {String} date Date sting to be checked
 * @return {Boolean}
 */

export default function isValidISODate(date) {
    return moment.utc(date, moment.ISO_8601, true).isValid()
        && /^\d{4}-\d{2}-\d{2}/.test(date);
}
